module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/136-iran-2d71474c5ebb82656f4d240f55782202.svg";